import { Redirect, Route, Switch } from 'react-router-dom';
// Helpers
import AuthHelper from './helpers/auth';
// Layouts
import MapLayout from './layouts/MapLayout';
// Containers
import MapPage from './containers/MapPage';
import DirectionsPage from './containers/LocationDetailPage/DirectionsPage';
import LocationDetailPage from './containers/LocationDetailPage';
import StreetViewPage from './containers/StreetViewPage';

const routes = [
	// { path: '/', exact: true, isPrivate: false, Layout: MapLayout, Component: MapPage }
	{ path: '/', exact: true, isPrivate: false, Layout: MapLayout, Component: MapPage },
	{ path: '/location/id', exact: true, isPrivate: false, Layout: MapLayout, Component: LocationDetailPage },
	{ path: '/location/directions', exact: true, isPrivate: false, Layout: MapLayout, Component: DirectionsPage },
	{ path: '/street-view', exact: true, isPrivate: false, Layout: null, Component: StreetViewPage }
];

const getRedirectedPath = (location) => {
	if (location.pathname.split('?')[0] === '/login' && location.pathname.split('?').length > 1) {
		return location.pathname + location.search + location.hash;
	}

	// Skip the redirection from these routes
	if (['/login', '/callback/cas', '/logout'].indexOf(location.pathname.split('?')[0]) !== -1) {
		return '/login';
	}

	return `/login?path=${location.pathname + location.search + location.hash}`;
};

const PrivateRoute = ({ layout: Layout, component: Component, location, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (AuthHelper.isAuthenticated()) {
				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			} else {
				return (
					<Redirect
						to={{
							pathname: getRedirectedPath(location),
							state: { from: location }
						}
						}
					/>
				);
			}
		}}
	/>
);

const Routes = ({ location }) => {
	return (
		<Switch location={location} >
			{
				routes.map(({ path, exact, isPrivate, Layout, Component }) => {
					if (isPrivate) {
						return (
							<PrivateRoute
								key={0}
								path={path}
								exact={exact}
								layout={Layout}
								component={Component}
								location={location}
							/>
						);
					} else {
						return (
							<Route
								key={0}
								path={path}
								exact={exact}
								render={props => (
									Layout ? (
										<Layout location={location} >
											<Component {...props} />
										</Layout>
									) : (
										<Component {...props} />
									)
								)}
							/>
						);
					}
				})}
			<Route render={props => (AuthHelper.isAuthenticated() ? <Redirect to={'/'} /> : <Redirect to={getRedirectedPath(props.location)} />)} />
		</Switch>
	);
};

export default Routes;